// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"100":"5fc42593","107":"c6a9248a","411":"377d4826","472":"088e570e"}[chunkId] + ".chunk.js";
};